import { formatDateRu, toLocalParts } from '@pms/shared';

/**
 * Штамп на фотографии: дата, время, участок, агрегат, номер смены.
 *
 * Нужен, чтобы нельзя было переслать вчерашний снимок или чужой участок.
 * Наносится на устройстве перед отправкой — сервер получает уже помеченный файл.
 */

export interface StampContext {
  takenAt: Date;
  siteName: string;
  shiftNumber: number;
  machineName?: string | undefined;
}

/** Текст штампа. Вынесен отдельно от рисования, чтобы его можно было проверить тестом. */
export function buildStampLines(context: StampContext): string[] {
  const { date, minuteOfDay } = toLocalParts(context.takenAt);
  const hours = String(Math.floor(minuteOfDay / 60)).padStart(2, '0');
  const minutes = String(minuteOfDay % 60).padStart(2, '0');

  const place = [context.siteName, context.machineName].filter(Boolean).join(' · ');

  return [
    `${formatDateRu(date)} ${hours}:${minutes}`,
    `${place} · смена ${context.shiftNumber}`,
  ];
}

/** Рисует штамп в нижней части кадра. Размер шрифта — от ширины снимка. */
export function drawStamp(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  context: StampContext,
): void {
  const lines = buildStampLines(context);
  const fontSize = Math.max(16, Math.round(width / 32));
  const padding = Math.round(fontSize * 0.6);
  const lineHeight = Math.round(fontSize * 1.35);
  const barHeight = lineHeight * lines.length + padding * 2;

  ctx.save();
  ctx.fillStyle = 'rgba(0, 0, 0, 0.55)';
  ctx.fillRect(0, height - barHeight, width, barHeight);

  ctx.fillStyle = '#ffffff';
  ctx.font = `600 ${fontSize}px system-ui, sans-serif`;
  ctx.textBaseline = 'top';

  lines.forEach((line, index) => {
    ctx.fillText(line, padding, height - barHeight + padding + index * lineHeight);
  });
  ctx.restore();
}
